module.exports = __webpack_public_path__ + "img/bg_hexagon_token_bg.bbf2bb49.png";